import React from 'react';

interface AnimatedButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  className?: string;
  type?: "button" | "submit";
}

const AnimatedButton: React.FC<AnimatedButtonProps> = ({ text, href, onClick, className = "", type = "button" }) => {
  const content = (
    <>
      {/* Camada de Shimmer Circular (Aura) */}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none opacity-60">
        <div className="shimmer-container">
          <div className="shimmer-gradient"></div>
        </div>
      </div>

      {/* Camada de Onda (Fixada dentro do overflow) */}
      <div className="shimmer-onda"></div>

      {/* Borda de brilho suave */}
      <div className="absolute inset-0 z-0 pointer-events-none opacity-40">
        <div style={{
          position: 'absolute',
          width: '150%',
          height: '150%',
          background: 'linear-gradient(90deg, transparent, #ffffff, transparent)',
          animation: 'borderBeamRotation var(--speed) infinite linear',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}></div>
      </div>

      {/* Fundo verde suave com mini degradê */}
      <div className="absolute inset-[1.5px] bg-gradient-to-b from-[#bbf7d0] via-[#86efac] to-[#4ade80] rounded-full z-[1]"></div>

      {/* Esfumaçado radial na parte de baixo */}
      <div className="bottom-glow"></div>

      {/* Fundo branco de hover */}
      <div className="fundo-white"></div>

      {/* Ícone móvel */}
      <div className="wrapper-icones">
        <div className="w-1.5 h-1.5 bg-white rounded-full group-hover:hidden"></div>
        <svg xmlns="http://www.w3.org/2000/svg" className="hidden group-hover:block w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </div>

      {/* Textos */}
      <div className="relative z-10 w-full h-full flex items-center justify-center px-10">
        <span className="texto-principal whitespace-nowrap tracking-wide">
            {text}
        </span>

        <span className="texto-hover whitespace-nowrap">
            Falar agora
        </span>
      </div>
    </>
  );

  const baseClasses = `aura-button group isolate inline-flex items-center cursor-pointer overflow-hidden rounded-full relative bg-[#39B54A] min-h-[58px] ${className}`;

  if (href) {
    return (
      <a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel={href.startsWith('http') ? 'noopener noreferrer' : undefined} className={baseClasses}>
        {content}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} className={baseClasses}>
      {content}
    </button>
  );
};

export default AnimatedButton;